export default __webpack_public_path__ + "sound/notification.5f1fee46481f6a9e258576735bb8af2e.mp3";